import routeName from '../constant';
import { guideRoutes } from '@/utils/guideRoutes';

const routes = [
    {
        path: 'payoff-interest-terms',
        name: routeName.PAY_OFF_INTEREST_TERMS,
        component: () => import('@/views/aplCatl640and631/C2/landingPage/Index.vue'),
        meta: { auth: true, metaTitle: '清償自動墊繳保費本息說明', leaveAlert: true, code: 'C2', unableBack: true },
    },
    {
        path: 'payoff-interest',
        name: routeName.PAY_OFF_INTEREST,
        component: () => import('@/views/aplCatl640and631/C2/payoffInterest/Index.vue'),
        meta: { auth: true, metaTitle: '清償自動墊繳保費本息', leaveAlert: true, code: 'C2', unableBack: true },
        beforeEnter: (to, from, next) => {
            const whiteList = [routeName.PAY_OFF_INTEREST_TERMS, routeName.CONFIRM_DATA];
            const guideRoute = guideRoutes(from, whiteList, true);
            next(guideRoute);
        },
    }
];

export default routes;
